module.exports = __webpack_public_path__ + "img/2.46bfa9ee.jpg";